<cam-overlay-panel [panelConfig]="this.panelConfig">
  <ng-template #panelTrigger>
    <cam-button type="secondary" [size]="this.size()" icon="infos" [stopPropagationActivation]="false">
      @if (this.label(); as label) {
        {{ label }}
      }
    </cam-button>
  </ng-template>
  <ng-template #panelContent>
    <div class="shortcuts-list">
      <cam-text size="sm" [isBold]="true">{{ 'grid.editabled.shortcut.title' | translate }}</cam-text>
      @for (hint of this.shortcutHints; track hint.label) {
        <div class="shortcut-row">
          @if (hint.combo) {
            <cam-badge size="xs" [value]="hint.combo"></cam-badge>
          }
          <cam-text size="sm" [isBold]="!!hint.children">{{ hint.label | translate }}</cam-text>
        </div>
        @for (child of hint.children; track child.combo) {
          <div class="shortcut-row is-child">
            <cam-badge size="xs" [value]="child.combo!"></cam-badge>
            <cam-text size="sm" color="secondary">{{ child.label | translate }}</cam-text>
          </div>
        }
      }
    </div>
  </ng-template>
</cam-overlay-panel>
